import { translations } from "./translations";
import { WHATSAPP_PHONE } from "./contact-config.js";

function getCurrentLanguage() {
  return localStorage.getItem("language") || "ro";
}

function getWhatsAppStrings(lang) {
  return (
    translations[lang]?.common?.whatsapp ||
    translations.en.common.whatsapp
  );
}

function buildWhatsAppUrl(lang) {
  const { prefill } = getWhatsAppStrings(lang);
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(prefill)}`;
}

function updateWhatsAppFloat() {
  const link = document.getElementById("whatsapp-float");
  if (!link) return;

  const lang = getCurrentLanguage();
  const { label } = getWhatsAppStrings(lang);

  link.href = buildWhatsAppUrl(lang);
  link.setAttribute("aria-label", label);
  link.setAttribute("title", label);
}

export function initWhatsAppFloat() {
  updateWhatsAppFloat();
  document.addEventListener("languageChanged", updateWhatsAppFloat);
}
